import GetHelpText from '@features/Checkout/components/GetHelpText';
// import { getLayout as getSiteLayout } from '@layouts/DefaultLayout';
import { getLayout as getSiteLayout } from '@layouts/DefaultLayout';

const CheckoutLayout = ({ children }) => <>{children}</>;

export const getLayout = (page, props) =>
  getSiteLayout(<CheckoutLayout>{page}</CheckoutLayout>, {
    ...props,
    noFooter: false,
    noPrimaryMenuItems: true,
    noSignupButton: true,
    menuAddons: [<GetHelpText />],
    minimalFooter: true,
  });

export default CheckoutLayout;
